import React from "react"
import Container from "./Container"
import ImageWrapper from "./ImageWrapper"
import Section from "./Section"
import TextWrapper from "./TextWrapper"
import { ListItem, UnorderedList } from "./UnorderedLists"
import CheckMark from "../../images/home/check.svg"
import paymentAndBillingData from "../../data/pageSections/home/paymentAndBilling"
import H2 from "../typography/H2"
import ContainerNoPadding from "./ContainerNoPadding"
import P from "../typography/P"

const PaymentAndBillingWrapper = () => {
  const {
    titleIcon,
    title,
    description,
    graphic,
    imageLeft,
    benefits,
    tint,
    textLong,
  } = paymentAndBillingData

  return (
    <Section tint={tint}>
      <ContainerNoPadding>
        <H2 align="center">
          Streamline Payment Collection & Boost Revenue with Integrated Merchant
          Processing and Billing
        </H2>
      </ContainerNoPadding>
      <Container>
        <TextWrapper imageLeft={imageLeft}>
          <P style={{ fontSize: "22px" }}>
            Collecting payments, managing subscriptions, and capturing donations
            online is now a breeze with MindMe’s integrated merchant processing
            solution. Easily set up items to sell and market them using text and
            email campaigns, QR codes, landing pages, branded checkout pages, or
            directly on your website.
          </P>
          <P style={{ fontSize: "22px" }}>
            Designed for small businesses and nonprofits, our platform
            simplifies digital payments and subscription management—so you can
            focus on growing your revenue.
          </P>
          <UnorderedList>
            {benefits &&
              benefits.map(({ benefitName }) => (
                <ListItem>
                  <img
                    className="margin-right-10"
                    src={CheckMark}
                    alt="check"
                    title="check"
                  />
                  {benefitName}
                </ListItem>
              ))}
          </UnorderedList>
        </TextWrapper>
        <ImageWrapper width="30%" imageLeft={imageLeft} short={textLong}>
          {graphic}
        </ImageWrapper>
      </Container>
    </Section>
  )
}

export default PaymentAndBillingWrapper
